import { Modal, ModalProps } from 'ui/Modal'
import { AuditLogs } from '../AuditLogs'
import { Membership } from '@trybeapp/sdk'
import { FC } from 'react'

interface Props extends Pick<ModalProps, 'isOpen' | 'onClose'> {
  membershipId: Membership['id'] | undefined
}

export const MembershipAuditLog: FC<Props> = ({ isOpen, membershipId, onClose }) => {
  return (
    <Modal title="Audit log" isOpen={isOpen} onClose={onClose}>
      {membershipId && <AuditLogs ignoreVerbose showExpanded subjectId={membershipId} />}
    </Modal>
  )
}
